import { useNavigate } from "react-router-dom";
import { Card } from "@/components/Widgets";
import { XCircle } from "@phosphor-icons/react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="max-w-md mx-auto mt-16 fade-up">
      <Card className="text-center p-10" testid="payment-cancel-card">
        <XCircle size={56} weight="fill" className="text-muted-foreground mx-auto mb-4" />
        <h2 className="font-head font-bold text-2xl">Checkout canceled</h2>
        <p className="text-sm text-muted-foreground mt-2">No charge was made. You can subscribe anytime.</p>
        <button data-testid="back-billing-btn" onClick={() => navigate("/billing")}
          className="mt-6 bg-primary text-primary-foreground font-semibold px-5 py-2.5 text-sm font-semibold hover:bg-primary/90 transition-colors duration-200">Back to plans</button>
      </Card>
    </div>
  );
}
